import { requestsRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { RequestsKey } from './types';
import { useContext } from 'react';
import { OrganizationContext } from '@/components/OrganizationProvider/OrganizationProvider';

type UseGetRequestActivitiesParams = { id: number };

export default function useGetRequestActivities({
  id,
}: UseGetRequestActivitiesParams) {
  const { organizationId } = useContext(OrganizationContext);
  return useQuery({
    queryKey: [...RequestsKey.ACTIVITIES(id), organizationId],
    queryFn: () => requestsRepo.getRequestActivities(id),
  });
}
